import CustomButton from "./CustomButton";
import Popup from "./Popup";
import { formatDate } from "__utilities/functions/public";
import { subscriptionPeriodEnd } from "__utilities/functions/subscription";

/**
 * Cancelling does not end access. The subscription stays active until the end of the period
 * already paid for, and the card stays on file so resuming later needs no card details. The
 * copy must not suggest anything is lost now.
 */
export default function SubscriptionCancelPopup({
  userInfo,
  keepSubscription,
  confirmCancellation,
}) {
  const periodEnd = formatDate(subscriptionPeriodEnd(userInfo));

  return (
    <Popup styles={"w-[50%]"}>
      <div className="flex flex-col w-full h-full justify-center items-center gap-y-4 p-5">
        <p className="text-center text-primaryBlue font-latoBold text-[22px]">
          Er du sikker på, du ønsker at opsige dit abonnement?
        </p>
        <p className="text-center font-normal text-textXLightGray">
          {periodEnd
            ? `Dit abonnement ophører den ${periodEnd}. Du har fuld adgang til alle premium-funktioner indtil da.`
            : "Dit abonnement ophører ved udløbet af den periode, du har betalt for. Du har fuld adgang til alle premium-funktioner indtil da."}
          <br />
          Du kan gentegne dit abonnement på et hvert tidspunkt under dine
          profilindstillinger.
        </p>
        <div className="flex flex-row w-full justify-center gap-x-5">
          <CustomButton
            onClick={keepSubscription}
            text="BEHOLD ABONNEMENT"
            styles={
              "w-1/2 border border-primaryBlue bg-[#FFFFFF] text-[#003057] font-latoBold text-standardXSmall"
            }
          />
          <CustomButton
            onClick={confirmCancellation}
            text="BEKRÆFT OPSIGELSE"
            styles={"w-1/2 text-standardXSmall font-latoBold"}
          />
        </div>
      </div>
    </Popup>
  );
}
